import { Button } from "@mui/material";
import { useNavigate } from "react-router";
import { TiArrowBack } from "react-icons/ti";
import { useGetProject } from "../api/getProjects";
import moment from "moment";
import { ReactFilesPreview } from 'react-files-preview';
import 'react-files-preview/dist/style.css'  /* import css file*/
import { useGetSignatoryAgreement } from "../api/getSignatoryAgreement";
import { useGetStructureBankAccount } from "../api/getStructureBankAccount";
import { useGetOperationalContact } from "../api/getOperationalContact";
import { useGetAdministrativeContact } from "../api/getAdministrativeContact";
import { useGetAttachment } from "../api/getAttachment";

import { clients } from "../../../lib/axios";

import axios from 'axios';
import { useEffect, useState } from "react";
import { useGetAxe } from "../api/getAxes";
import { getStatusByLang, getStatusColor, getStatusLibelle } from "../../../utils/monthDiff";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../../utils/formatCurrency";
import { NavLink } from "react-router-dom";

interface Props {
  projectId?: string;
}

export const ProjectsDetail = ({ projectId }:Props) => {
  const navigate = useNavigate();  
  const {t, i18n} = useTranslation("common");
  // Get current language
  let lang = i18n.language;

  const { data: project } = useGetProject(projectId); 
  // TODO: Get idSignatoryAgreement
  const { data: signatoryAgreement } = useGetSignatoryAgreement(project?.idSignatoryAgreement); 
  // TODO: Get idStructureBankAccount
  const { data: structureBankAccount } = useGetStructureBankAccount(project?.idStructureBankAccount); 
  // TODO: Get idOperationalContact
  const { data: operationalContact } = useGetOperationalContact(project?.idOperationalContact); 
  // TODO: Get idAdministrativeContact
  const { data: administrativeContact } = useGetAdministrativeContact(project?.idAdministrativeContact); 
  // TODO: Get idAttachment
  const { data: attachment } = useGetAttachment(project?.idAttachment); 

  const { data: axe } = useGetAxe(project?.idAxe); 

  const [files, setFiles] = useState([] as File[]);

  useEffect(()=>{
    if(attachment) {
      const getFiles = async() => {
        // const axios = await clients();
        const fileURLs = [];

        if(attachment.statuts) fileURLs.push('https://'+ attachment.statuts);
        if(attachment.previousAnnualReport) fileURLs.push('https://'+ attachment.previousAnnualReport);
        if(attachment.otherFile) fileURLs.push('https://'+ attachment.otherFile);
        if(attachment.chronogram) fileURLs.push('https://'+ attachment.chronogram);
        if(attachment.budget) fileURLs.push('https://'+ attachment.budget);
        if(attachment.applicationFile) fileURLs.push('https://'+ attachment.applicationFile);

        let newFiles = [];
        for(let i=0; i < fileURLs.length; i++) {
          let url = fileURLs[i];
          let filenameSplit = url.split("/");
          let filename = filenameSplit[filenameSplit.length - 1];
          try {
            const response = await axios.get(url, { responseType: 'arraybuffer' });

            let file = new File([response.data], filename, { type: response.headers["content-type"] } );
            newFiles.push(file);
          } catch(e) {
            console.log("Erreur ", e);
          }
        }

        setFiles(newFiles);
      };

      getFiles();
    }
  }, [attachment]);


  return (
  <div>
    <div className="bg-orange change-request-title d-flex ">
       { t('projet.otherTitle') }
      <div className="ml-auto d-flex">
        <NavLink 
            className={"btn btn-default"}
            to={`/list/projects`}
          >
          { t('app.back') } 
        </NavLink> 
        { project?.status === "Draft" &&
            <NavLink 
                className={"btn btn-primary"}
                to={`/update/projects/${project?.id}`}
              >
              { t('app.update') } 
            </NavLink>
        }  
      </div>
    </div>
    
    <div
      className="wf-change-request-content"
      style={{
        // display: "flex",
        // flexDirection: "column",
        // alignContent: "center",
        // justifyContent: "center",
        // paddingTop: "15px",
        // gap: "20px",
        padding: "15px",
        paddingLeft: "2.5%",
        paddingRight: "2.5%"
      }}
    >
       
       <div >
        <div className="d-flex flex-column">
          <div className="mt-4">
              <h4>{ t('projet.generalInfos.title') }</h4>
          </div>
          <hr/>
          <div className="row mb-4">

            <div className="col-12 col-md-6  mt-4">
              <label className="form-label mb-2 w-100">{ t('projet.generalInfos.name') }</label>
              <span>{ project?.name }</span>
            </div>
            {/* <div className="col-12 col-md-6  mt-4">
              <label className="form-label mb-2 w-100">{"Partenaire Id"} : { project?.idAccount } </label> 
            </div> */}
            <div className="col-12 col-md-6  mt-4">
              <label className="form-label mb-2 w-100">{ t('projet.generalInfos.axe') }</label>
              <span> { axe?.label }</span>
            </div>
            <div className="col-12 col-md-6  mt-4">
              <label className="form-label mb-2 w-100">{ t('projet.generalInfos.beneficiaryNumber') }</label>
              <span> { project?.beneficiaryNumber }</span>
            </div>
            <div className="col-12 col-md-6  mt-4">
              <label className="form-label mb-2 w-100">{ t('projet.generalInfos.locationCountry') }</label>
              <span>{ project?.locationCountry }</span>
            </div>
            <div className="col-12 col-md-6  mt-4">
              <label className="form-label mb-2 w-100">{ t('projet.generalInfos.locationCity') }</label>
              <span>{ project?.locationCity }</span>
            </div>
            <div className="col-12 col-md-6  mt-4">
              <label className="form-label mb-2 w-100">{ t('projet.generalInfos.periode') }</label>
              <span>{ moment(project?.startDate).format("DD/MM/YYYY") + " - " + moment(project?.endDate).format("DD/MM/YYYY") }</span>
            </div>
            {/* <div className="col-12 col-md-6  mt-4">
              <label className="form-label mb-2 w-100">{"Etape"} : {project?.step}</label>
            </div> */}
            <div className="col-12 col-md-6  mt-4">
              <label className="form-label mb-2 w-100">{ t('projet.generalInfos.consultantInvolved') }</label>
              <span>{ project?.consultantInvolved }</span>
            </div>
            <div className="col-12 col-md-6  mt-4">
              <label className="form-label mb-2 w-100">{t('projet.generalInfos.provisionalBudget') }</label>
              <span>{ formatCurrency(project?.provisionalBudget!) }</span>
            </div>
            <div className="col-12 col-md-6  mt-4">
              <label className="form-label mb-2 w-100">{ t('projet.generalInfos.financialSupportRequest') }</label>
              <span>{ formatCurrency(project?.financialSupportRequest!) }</span>
            </div>
            <div className="col-12 col-md-6  mt-4">
              <label className="form-label mb-2 w-100">{t('projet.generalInfos.useOfSupportRequest') }</label>
              <span>{ project?.useOfSupportRequest }</span>
            </div>
            <div className="col-12 col-md-6  mt-4">
              <label className="form-label mb-2 w-100">{t('projet.generalInfos.otherFinancialPartner') }</label>
              <span>{ project?.otherFinancialPartner }</span>
            </div>
            <div className="col-12 col-md-6  mt-4">
              <label className="form-label mb-2 w-100">{t('projet.generalInfos.status') }</label>
              <span className={ `badge ${getStatusColor(project?.status!)} w-50 p-2` } >{ getStatusByLang(project?.status!, lang) }</span>
            </div>
            {/* <div className="col-12 col-md-6  mt-4">
              <label className="form-label mb-2 w-100">{"Actions"} : {project?.actions?.map(action => action.label).join(', ')}</label>
            </div> */}

            <div className="col-12 col-md-6  mt-4">
              <label className="form-label mb-2 w-100">{t('projet.generalInfos.summary') }</label>
              <div dangerouslySetInnerHTML={{__html:project?.summary??""}} ></div>  
            </div>
            <div className="col-12 col-md-6  mt-4">
              <label className="form-label mb-2 w-100">{t('projet.generalInfos.comment') }</label>
              <div dangerouslySetInnerHTML={{__html:project?.comment??""}} ></div>  
            </div>
          </div>

          {
            project && project.idSignatoryAgreement && (
              <>
                <div className="mt-4">
                    <h4>{ t('projet.signataires.title') }</h4>
                </div>
                <hr/>
                <div className="row mb-4">
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.signataires.name') }</label>
                    <span>{ signatoryAgreement?.lastname + " " + signatoryAgreement?.firstname }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.signataires.email') }</label>
                    <span>{ signatoryAgreement?.email }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.signataires.mobilePhone') }</label>
                    <span>{ signatoryAgreement?.mobilePhone }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.signataires.fixPhone') }</label>
                    <span>{ signatoryAgreement?.fixPhone }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.signataires.qualityOfSignatory') }</label>
                    <span>{ signatoryAgreement?.qualityOfSignatory }</span>
                  </div>

                </div>
              </>
            )
          }
          

          {
            project && project.idStructureBankAccount && (
              <>
                <div className="mt-4">
                    <h4>{ t('projet.bank.title') }</h4>
                </div>
                <hr/>
                <div className="row mb-4">
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.bank.iban') }</label>
                    <span>{ structureBankAccount?.iban }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.bank.accountOwner') }</label>
                    <span>{ structureBankAccount?.accountOwner }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.bank.bankName') }</label>
                    <span>{ structureBankAccount?.bankName }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.bank.bankAddress') }</label>
                    <span>{ structureBankAccount?.bankAddress }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.bank.cityOfBank') }</label>
                    <span>{ structureBankAccount?.cityOfBank }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.bank.swiftCode') } </label>
                    <span>{ structureBankAccount?.swiftCode }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.bank.poBox') }</label>
                    <span>{ structureBankAccount?.poBox }</span>
                  </div>
                </div>
              </>
            )
          }
            
          {
            project && project.idOperationalContact && (
              <>
                <div className="mt-4">
                    <h4>{ t('projet.operational.title') }</h4>
                </div>
                <hr/>
                <div className="row mb-4">
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.operational.lastname') }</label>
                    <span>{ operationalContact?.lastname }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.operational.firstname') }</label>
                    <span>{ operationalContact?.firstname }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.operational.mobilePhone') }</label>
                    <span>{ operationalContact?.mobilePhone }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.operational.fixPhone') }</label>
                    <span>{ operationalContact?.fixPhone }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.operational.email') }</label>
                    <span>{ operationalContact?.email }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.operational.adresse') }</label>
                    <span>{ operationalContact?.adresse }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.operational.function') }</label>
                    <span>{ operationalContact?.function }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.operational.regionOfContact') }</label>
                    <span>{ operationalContact?.regionOfContact }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.operational.cityOfContact') }</label>
                    <span>{ operationalContact?.cityOfContact }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.operational.postalBoxOfContact') }</label>
                    <span>{ operationalContact?.postalBoxOfContact }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.operational.districtOfContact') }</label>
                    <span>{ operationalContact?.districtOfContact }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.operational.streetAndNumber') }</label>
                    <span>{ operationalContact?.streetAndNumber }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.operational.departmentOfContact') }</label>
                    <span>{ operationalContact?.departmentOfContact }</span>
                  </div>
                </div>
              </>
            )
          }

          {
            project && project.idAdministrativeContact && (
              <>
                <div className="mt-4">
                    <h4>{ t('projet.administratif.title') }</h4>
                </div>
                <hr/>
                <div className="row mb-4">
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.administratif.lastname') }</label>
                    <span>{ administrativeContact?.lastname }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.administratif.firstname') }</label>
                    <span>{ administrativeContact?.firstname }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.administratif.mobilePhone') }</label>
                    <span>{ administrativeContact?.mobilePhone }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.administratif.fixPhone') }</label>
                    <span>{ administrativeContact?.fixPhone }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.administratif.email') }</label>
                    <span>{ administrativeContact?.email }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.administratif.civility') }</label>
                    <span>{ administrativeContact?.civility}</span>
                  </div>

                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.operational.function') }</label>
                    <span>{ administrativeContact?.function }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.operational.regionOfContact') }</label>
                    <span>{ administrativeContact?.region }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.operational.cityOfContact') }</label>
                    <span>{ administrativeContact?.city }</span>
                  </div>
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{ t('projet.operational.postalBoxOfContact') }</label>
                    <span>{ administrativeContact?.postalBox }</span>
                  </div>
                </div>
                
              </>
            )
          }

          {/*
            project && project.idSignatoryAgreement && (
              <>
                <div className="mt-4">
                    <h4>Signatory Agreement</h4>
                </div>
                <hr/>
                <div className="row mb-4">
                  <div className="col-12 col-md-6  mt-4">
                    <label className="form-label mb-2 w-100">{"Nom"} : { signatoryAgreement?.name}</label>
                  </div>
                </div>
              </>
            )
          */}
          {
            project && project.idAttachment && (
              <>
                <div className="mt-4">
                    <h4>{ t('projet.attachment.title') }</h4>
                </div>
                <hr/>
                <div className="row mb-4">
                  <div className="col-12 col-md-12  mt-4 mb-4">
                    <ReactFilesPreview
                        accept="*/*"
                        downloadFile
                        fileHeight="w-44"
                        fileWidth="h-32"
                        files={files}
                        getFiles={function Nl(){}}
                        maxFileSize={50242880}
                        //maxFiles={7}
                        multiple
                        onChange={function Nl(){}}
                        onClick={function Nl(){}}
                        onDrop={function Nl(){}}
                        onError={function Nl(){}}
                        onRemove={function Nl(){}}
                        removeFile={false}
                        rounded
                        showFileSize
                        showSliderCount
                        width="basis-11/12"
                      />
                  </div>
                </div>
              </>
            )
          }
           
        </div>    
      </div>

    </div>

    <div className="bg-orange change-request-title d-flex ">
      <div className="ml-auto d-flex">
        <NavLink 
            className={"btn btn-default"}
            to={`/list/projects`}
          >
          { t('app.back') } 
        </NavLink> 
        { project?.status === "Draft" &&
            <NavLink 
                className={"btn btn-primary"}
                to={`/update/projects/${project?.id}`}
              >
              { t('app.update') } 
            </NavLink>
        }     
        
      </div>
    </div>


  </div>);
}